import lightslider from '../../assets/js/lightslider.min.js?raw';
import gsap from '../../assets/js/gsap.min.js?raw';
import scrollTrigger from '../../assets/js/ScrollTrigger.min.js?raw';
import froogaloop from '../../assets/js/froogaloop.min.js?raw';
import lightgallery from '../../assets/js/lightgallery.min.js?raw';
import socialshare from '../../assets/js/socialshare.js?raw';
import viewport from './site/viewport.js?raw';
import arrow from '../../assets/js/arrow.js?raw';
import stopallvimeo from '../../assets/js/stopallvimeo.js?raw';
import lightsliderInit from '../../assets/js/init-lightslider.min.js?raw';
import doresize from '../../assets/js/doresize.js?raw';
import fontsize from '../../assets/js/fontsize_changer.min.js?raw';
function run(source) {
  const script = document.createElement('script');
  script.text = source;
  document.head.appendChild(script);
}

[
  lightslider,
  gsap,
  scrollTrigger,
  froogaloop,
  lightgallery,
  socialshare,
  viewport,
  arrow,
  stopallvimeo,
  lightsliderInit,
  doresize,
  fontsize,
].forEach(run);
